const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div id="speaking-event">
  <div class="o-container o-container--prose o-container--pad">
    <div class="o-container__content">
      `);
                this.echo(this.include(context, this.source, this.loadTemplate(`e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, 4, 166), new Map([[`class`, `o-rhythm--generous`]]), true, false, 4));
                this.echo(`    </div>
  </div>
  `);
                this.echo(this.include(context, this.source, `@cloudfour/components/ground-nav/ground-nav.twig`, new Map([[`menu`, new Map([[`items`, new Map([[0, new Map([[`link`, `/does`], [`title`, `What We Do`], [`current`, true]])], [1, new Map([[`link`, `/believes`], [`title`, `Our Approach`]])], [2, new Map([[`link`, `/made`], [`title`, `Our Work`]])], [3, new Map([[`link`, `/thinks`], [`title`, `Articles`]])], [4, new Map([[`link`, `/presents`], [`title`, `Speaking`]])], [5, new Map([[`link`, `/contributes`], [`title`, `Labs`]])], [6, new Map([[`link`, `/is`], [`title`, `Team`]])], [7, new Map([[`link`, `/portland-device-lab`], [`title`, `Device Lab`]])], [8, new Map([[`link`, `https://cloudfour-patterns.netlify.app/`], [`title`, `Patterns`]])], [9, new Map([[`link`, `https://www.responsivefieldday.com/`], [`title`, `Responsive Field Day`]])]])]])], [`social`, new Map([[`items`, new Map([[0, new Map([[`link`, `https://twitter.com/cloudfour`], [`title`, `Follow us on Twitter`], [`icon`, `brands/twitter`]])], [1, new Map([[`link`, `https://github.com/cloudfour`], [`title`, `Find us on GitHub`], [`icon`, `brands/github`]])], [2, new Map([[`link`, `https://www.instagram.com/cloudfourpdx/`], [`title`, `Follow us on Instagram`], [`icon`, `brands/instagram`]])], [3, new Map([[`link`, `https://www.linkedin.com/company/cloud-four`], [`title`, `Follow us on LinkedIn`], [`icon`, `brands/linkedin`]])]])]])], [`action`, new Map([[`lead_in`, `Let’s discuss your project!`], [`title`, `Email us`], [`link`, `mailto:info@cloudfour.com`], [`icon`, `envelope`]])], [`organization`, new Map([[`name`, `Cloud Four, Inc.`], [`address`, new Map([[`street_address`, `510 SW 3rd Ave, Suite 420`], [`address_locality`, `Portland`], [`address_region`, `Oregon`], [`postal_code`, `97204`], [`address_country`, `USA`]])], [`email`, `info@cloudfour.com`], [`telephone`, `+1 (503) 290-1090`], [`url`, `https://cloudfour.com/`], [`founding_date`, `2007-12-13`]])]]), false, false, 116));
                this.echo(`</div>
`);
            }

            getTemplateName() {
                return `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, ``);
            }
        }],
        [166, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/rhythm/rhythm.twig`, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, 4);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/rhythm/rhythm.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`          `);
                this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`level`,  -1], [`tag_name`, `h1`], [`content`, `Designing Progressive Web Apps`]]), false, false, 8));
                this.echo(`          `);
                this.echo(this.include(context, this.source, this.loadTemplate(`e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, 13, 159), undefined, true, false, 13));
                this.echo(`          <p>
            If you have a website—particularly one in Llanfairpwllgwyngyllgogerychwyrndrobwllllantysiliogogogoch that generates revenue for your organization—you need a Progressive Web App. So where do you begin? How do you decide which features of a Progressive Web App make sense for your users? What tools can make the process easier (or harder)? In this practical session, Jason will guide you through the key design decisions you’ll need to make about your Progressive Web App and how those decisions impact the scope of your project. He'll also teach you how to avoid common pitfalls and help you take full advantage of Progressive Web App technology.
          </p>
          <div class="u-pad-block-start-4">
            `);
                this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`level`, 1], [`tag_name`, `h2`], [`content`, `Resources`]]), false, false, 26));
                this.echo(`          </div>
          `);
                this.echo(this.include(context, this.source, `@cloudfour/objects/embed/demo/image.twig`, new Map([[`class`, `o-embed--wide`], [`src`, (context.has(`deck`) ? context.get(`deck`) : null)]]), false, false, 32));
                this.echo(`          <div class="o-button-group o-button-group--grow">
            `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`content_start_icon`, `brands/github`], [`label`, `GitHub`]]), false, false, 37));
                this.echo(`          </div>
          <div class="u-pad-block-start-4">
            `);
                this.echo(this.include(context, this.source, this.loadTemplate(`e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, 43, 160), new Map([[`level`, 1], [`tag_name`, `h2`], [`content`, `Watch`]]), false, false, 43));
                this.echo(`          </div>
          `);
                this.echo(this.include(context, this.source, this.loadTemplate(`e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, 53, 161), new Map([[`class`, `o-embed--wide`]]), true, false, 53));
                this.echo(`          <div class="u-pad-block-start-4">
            `);
                this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`level`, 1], [`tag_name`, `h2`], [`content`, `Presented at...`]]), false, false, 59));
                this.echo(`          </div>
          `);
                this.echo(this.include(context, this.source, this.loadTemplate(`e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, 65, 164), undefined, true, false, 65));
                this.echo(`          <div class="feature-box u-pad-1 u-pull-inline-1">
            `);
                this.echo(this.include(context, this.source, this.loadTemplate(`e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, 91, 165), new Map([[`reverse`, true]]), false, false, 91));
                this.echo(`          </div>
          <p>
            <small>
              Thumbnail image by <a href="https://www.pexels.com/photo/white-blank-notebook-733857/">Tirachard Kumtanom</a>.
            </small>
          </p>
          `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`content_start_icon`, `arrow-left`], [`class`, `c-button--secondary`], [`label`, `All talks`]]), false, false, 107));
                this.echo(`        `);
            }

            getTemplateName() {
                return `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, ``);
            }
        }],
        [159, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/media/media.twig`, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, 13);

                this.blocks = new Map([
                    ['object', [this, 'block_object']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/media/media.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_object(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`              `);
                this.echo(this.include(context, this.source, `@cloudfour/components/avatar/avatar.twig`, new Map([[`src`, `https://cloudfour.com/wp-content/uploads/2016/07/jason.png`]]), false, false, 15));
                this.echo(`            `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`              <a href="https://cloudfour.com/is/jason-grigsby/">Jason Grigsby</a>
              <p class="speaker-title">Co-founder</p>
            `);
            }

            getTemplateName() {
                return `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, ``);
            }
        }],
        [160, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/heading/heading.twig`, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, 43);

                this.blocks = new Map([
                    ['subheading', [this, 'block_subheading']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/heading/heading.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_subheading(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                Smashing Conference (<time datetime="2018-10-23">Oct 23, 2018</time>)
              `);
            }

            getTemplateName() {
                return `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, ``);
            }
        }],
        [161, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/embed/embed.twig`, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, 53);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/embed/embed.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`              <iframe width="560" height="315" src="https://www.youtube.com/embed/Ty5jtMZXbmk" allowfullscreen></iframe>
            `);
            }

            getTemplateName() {
                return `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, ``);
            }
        }],
        [164, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/event-log/event-log.twig`, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, 65);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/event-log/event-log.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`              `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable((context.has(`events`) ? context.get(`events`) : null));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                context.set('loop', new Map([
                  ['parent', context.get('_parent')],
                  ['index0', 0],
                  ['index', 1],
                  ['first', true]
                ]));
                if ((typeof context.get('_seq') === 'object') && this.isCountable(context.get('_seq'))) {
                    let length = this.count(context.get('_seq'));
                    let loop = context.get('loop');
                    loop.set('revindex0', length - 1);
                    loop.set('revindex', length);
                    loop.set('length', length);
                    loop.set('last', (length === 1));
                }
                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`item`] = __value__;
                    this.echo(`                `);
                    this.echo(this.include(context, this.source, this.loadTemplate(`e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, 68, 163), context.get(`item`), true, false, 68));
                    this.echo(`              `);
                    (() => {
                        let loop = context.get('loop');
                        loop.set('index0', loop.get('index0') + 1);
                        loop.set('index', loop.get('index') + 1);
                        loop.set('first', false);
                        if (loop.has('length')) {
                            loop.set('revindex0', loop.get('revindex0') - 1);
                            loop.set('revindex', loop.get('revindex') - 1);
                            loop.set('last', loop.get('revindex0') === 0);
                        }
                    })();
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('item');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`            `);
            }

            getTemplateName() {
                return `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, ``);
            }
        }],
        [163, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/event-log/item.twig`, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, 68);

                this.blocks = new Map([
                    ['extra', [this, 'block_extra']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/event-log/item.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_extra(context, blocks = new Map()) {
                let macros = this.macros.clone();
                if (this.traceableMethod(this.getAttribute, 70, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `links`, new Map([]), `any`, false, false, false)) {
                    this.echo(this.include(context, this.source, this.loadTemplate(`e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, 71, 162), new Map([[`class`, `o-list--inline`]]), true, false, 71));
                }
            }

            getTemplateName() {
                return `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, ``);
            }
        }],
        [162, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/list/list.twig`, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, 71);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/list/list.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                          `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(this.traceableMethod(this.getAttribute, 75, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `links`, new Map([]), `any`, false, false, false));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`link`] = __value__;
                    this.echo(`                            <li>
                              <a href="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(77, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 77, this.source)(this.env, context.get(`link`), `link`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`">
                                `);
                    this.echo(this.env.getFilter('escape').traceableCallable(78, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 78, this.source)(this.env, context.get(`link`), `title`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`
                              </a>
                            </li>
                          `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('link');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`                        `);
            }

            getTemplateName() {
                return `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, ``);
            }
        }],
        [165, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/media/media.twig`, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, 91);

                this.blocks = new Map([
                    ['object', [this, 'block_object']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/media/media.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_object(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                `);
                this.echo(this.include(context, this.source, `@cloudfour/components/avatar/avatar.twig`, new Map([[`src`, `https://cloudfour.com/wp-content/uploads/2016/07/jason.png`]]), false, false, 95));
                this.echo(`              `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                <p><a href="https://cloudfour.com/is/jason-grigsby/"><strong>Jason Grigsby</strong></a> is one of the co-founders of Cloud Four, Mobile Portland and Responsive Field Day. He is the author of <a href="https://abookapart.com/products/progressive-web-apps">Progressive Web Apps</a> from A Book Apart. Follow him at <a href="https://twitter.com/grigs">@grigs</a>.</p>
              `);
            }

            getTemplateName() {
                return `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548');

let template = env.loadTemplate('e128dd9b41394ec3a18e9963090d16535c223a055a52433c5123f8e74d7af548');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/prototypes/speaking-event/example/single-speaker.twig", args: context }
     );
     return rendered;;
};